module.exports = "/assets/js/a28f0262e9b80e0f39adc5c98c57f9e6.svg";